import { ROLE, isClientRole } from '../../../constants/roles';

export const GROUP_KIND = Object.freeze({
    ADMINS: 'admins',
    AGENCY: 'agency',
    DIRECT: 'direct',
});

const byEmail = (a, b) => a.email.localeCompare(b.email);

/**
 * Группирует пользователей по дереву created_by: администраторы, каждое агентство со своими клиентами,
 * клиенты без агентства. Агентство показывается, если подходит само или подходит кто-то из его клиентов
 * (тогда оно выводится как контекст — `isOwnerMatched: false`).
 *
 * @param {Array<object>} users все видимые пользователи
 * @param {(user: object) => boolean} matches фильтр
 * @returns {Array<{ key: string, kind: string, title: string, owner: object|null, isOwnerMatched: boolean, members: Array<object> }>}
 */
export const buildUserTree = (users, matches) => {
    const agencies = users.filter(user => user.role?.code === ROLE.AGENCY).sort(byEmail);
    const agencyIds = new Set(agencies.map(agency => agency.id));
    const clients = users.filter(user => isClientRole(user.role?.code));

    const groups = [];

    const admins = users.filter(user => user.role?.code === ROLE.ADMIN && matches(user)).sort(byEmail);
    if (admins.length) {
        groups.push({
            key: GROUP_KIND.ADMINS,
            kind: GROUP_KIND.ADMINS,
            title: 'Администраторы',
            owner: null,
            isOwnerMatched: false,
            members: admins,
        });
    }

    agencies.forEach((agency) => {
        const members = clients
            .filter(client => client.created_by === agency.id && matches(client))
            .sort(byEmail);
        const isOwnerMatched = matches(agency);

        if (!isOwnerMatched && !members.length) return;

        groups.push({
            key: `${GROUP_KIND.AGENCY}-${agency.id}`,
            kind: GROUP_KIND.AGENCY,
            title: agency.email,
            owner: agency,
            isOwnerMatched,
            members,
        });
    });

    const direct = clients
        .filter(client => !agencyIds.has(client.created_by) && matches(client))
        .sort(byEmail);
    if (direct.length) {
        groups.push({
            key: GROUP_KIND.DIRECT,
            kind: GROUP_KIND.DIRECT,
            title: 'Клиенты без агентства',
            owner: null,
            isOwnerMatched: false,
            members: direct,
        });
    }

    return groups;
};

/**
 * Прямые подчинённые пользователя — они переподчиняются при деактивации или понижении роли.
 */
export const childrenOf = (users, userId) => users.filter(user => user.created_by === userId && !user.deleted_at);
